const sanitizeParams = (params) => {
    const entries = Object.entries(params);
    const newParams = entries.reduce((previous, [current, currentParam]) => {
        const removableValues = [undefined, null, ''];
        const shouldRemove = removableValues.includes(currentParam);
        return shouldRemove ? previous : Object.assign(Object.assign({}, previous), { [current]: currentParam });
    }, {});
    return newParams;
};
const getQueryString = (params) => {
    const sanitizedParams = sanitizeParams(params);
    const queryString = Object.entries(sanitizedParams)
        .map(([param, value]) => `${param}=${encodeURI(String(value))}`)
        .join('&');
    return queryString;
};
const objectToQueryString = (params, defaultParams = {}) => {
    const isInvalid = !params || Array.isArray(params) || typeof params !== 'object';
    if (isInvalid) {
        // eslint-disable-next-line no-console
        console.warn('Must be passed an object with key and value!');
        return getQueryString(defaultParams);
    }
    const newParams = Object.assign(Object.assign({}, params), defaultParams);
    return getQueryString(newParams);
};

export { objectToQueryString as default };
